import { CookieConsentBanner } from '@/components/CookieConsentBanner';
import { CookiePreferencesModal } from '@/components/CookiePreferencesModal';

export function CookieConsentWrapper() {
  return (
    <>
      <CookieConsentBanner />
      <CookiePreferencesModal />
    </>
  );
}
